import testimonialsJson from './testimonials.json';
import Avatar1 from './avatars/Avatar1.svg';
import Avatar2 from './avatars/Avatar2.svg';
import Avatar3 from './avatars/Avatar3.svg';
import Avatar4 from './avatars/Avatar4.svg';
import Avatar5 from './avatars/Avatar5.png';
import Avatar6 from './avatars/Avatar6.png';

export type TestimonialBannerColor = 'blue' | 'yellow' | 'green' | 'purple';

export type Testimonial = {
  name: string;
  title: string;
  quote: string;
  bannerColor: TestimonialBannerColor;
  iconColor: string;
  avatarUrl: string;
  skillTag: string;
  causeTag: string;
};

const AVATAR_BY_KEY: Record<string, string> = {
  avatar1: Avatar1,
  avatar2: Avatar2,
  avatar3: Avatar3,
  avatar4: Avatar4,
  avatar5: Avatar5,
  avatar6: Avatar6,
};

export const getTestomonials = (corporateClientName: string): Testimonial[] => {
  return ((testimonialsJson as Record<string, Testimonial[]>)[corporateClientName] ?? []).map(
    (entry) => ({
      ...entry,
      avatarUrl: AVATAR_BY_KEY[entry.avatarUrl] ?? entry.avatarUrl,
    }),
  );
};
